import { resources } from "@constants/hardcoded-strings";
import {
    ScoresValidationErrors,
} from "@idw-types/common/validation/verification-service-details-validation-errors/verification-service-details-validation-errors";
import { FormattedRpServiceConfiguration, FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { affectsTrustScore, hasAtLeastOneTrustScoreService, scoreComponentsDisable } from "@utils/scores/trust-score-util";
import { getAssertionScoreModifierPoints } from "@utils/scores/assertion-score-modifier-util";
import { FormattedRpServiceConfigurationScoreModifier } from "@idw-types/data/rp-service-configuration/rp-service-configuration-score";
import { isTrustScoreEnabled } from "@utils/scores/score-util";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";

export const getScoreValidationErrors = (rpServiceConfiguration: FormattedRpServiceConfiguration, trustScoreServiceOfferingIDs: Array<string>, scoreServiceOfferingIDs: Array<string>): ScoresValidationErrors => {
    let count = 0;
    const trustScoreValidationErrors = getTrustScoreValidationErrors(rpServiceConfiguration.serviceOfferings, trustScoreServiceOfferingIDs, scoreServiceOfferingIDs);
    const assertionScoreValidationErrors = getAssertionScoreValidationErrors(rpServiceConfiguration.assertionScoreModifiers);
    count = trustScoreValidationErrors.count + assertionScoreValidationErrors.count;

    return {
        assertionScore: assertionScoreValidationErrors,
        trustScore: trustScoreValidationErrors,
        count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.scores.tabName} errorCount={count} />
    };
};

const getAssertionScoreValidationErrors = (assertionScoreModifiers: Array<FormattedRpServiceConfigurationScoreModifier>) => {
    let count = 0;
    let noAssertionScoreValueSetError = null;

    if (assertionScoreModifiers.length) {
        const assertionScoreModifierPoints = getAssertionScoreModifierPoints(assertionScoreModifiers);
        if (assertionScoreModifierPoints === 0) {
            count++;
            noAssertionScoreValueSetError = (
                <ErrorAlert>
                    <span>{resources.pages.verificationServiceDetails.tabs.scores.subTabs.assertionScore.sections.assertionScoreModifiers.invalidAssertionScoreError}</span>
                </ErrorAlert>
            );
        }
    }


    return {
        noAssertionScoreValueSetError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.scores.subTabs.assertionScore.tabName} errorCount={count} />
    };

};

const getTrustScoreValidationErrors = (serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>, trustScoreServiceOfferingIDs: Array<string>, scoreServiceOfferingIDs: Array<string>) => {
    let count = 0;
    let noTrustScoreComponentEnabledError = null;
    const isEnabled = isTrustScoreEnabled(
        serviceOfferings,
        trustScoreServiceOfferingIDs
    )
    const trustScoreServiceOfferings = affectsTrustScore(serviceOfferings, trustScoreServiceOfferingIDs);
    const atLeastOneScoreComponentIsEnabled = !scoreComponentsDisable(trustScoreServiceOfferings);
    const hasOneTrustScoreServiceAtLeast = hasAtLeastOneTrustScoreService(serviceOfferings, scoreServiceOfferingIDs);
    if (isEnabled && hasOneTrustScoreServiceAtLeast && !atLeastOneScoreComponentIsEnabled) {
        count++;
        noTrustScoreComponentEnabledError = (
            <ErrorAlert>
                <span>{resources.pages.verificationServiceDetails.tabs.scores.subTabs.trustScore.sections.serviceOfferingWeights.error.noTrustScoreComponentEnabledError}</span>
            </ErrorAlert>
        );
    }

    return {
        noTrustScoreComponentEnabledError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.scores.subTabs.trustScore.tabName} errorCount={count} />
    };
};